import React, { useEffect, useState } from 'react';
import img from '@assets/images/heros/homepage.jpg';
import { useHistory } from 'react-router-dom';
import {  DateRangePickerComponent } from '../date-range-component';
import { LocationSelector } from '../location-component';
import { GuestsRoomsSelector } from '../guest-room-component';
import moment from 'moment';
import arrow from '@assets/images/gallery/right-arrow.svg';
import { useSelector } from 'react-redux';
import { ILoginState } from '@share/store/slices';
import { BlueButton, SearchSelection, SearchWrapper } from '@share/components';
import { SearchSvg } from '@share/assets';
import { FormattedMessage } from 'react-intl';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { isEmpty } from 'lodash';
import { HOTEL_RECENT_SEARCHES_LABEL, HOTELS_SELECTION_TYPE } from '@share/constants';
import { getNormalizedRoomsResponse } from '@share/utils';
import './style.scss'; 
import { HotelDatePicker } from '../date-range-component/hotel-date-picker';
interface Room {
  adultsCount: number;
  kidsAges: number[];
}
interface IMapStateToProps {
  loginStore: ILoginState;
}

const DashboardHero: React.FC = () => {
  const login = useSelector((state: IMapStateToProps) => state.loginStore);
  const [checkIn, setCheckIn] = useState<string>('');
  const [checkOut, setCheckOut] = useState<string>('');
  const [rooms, setRooms] = useState<Room[]>([{ adultsCount: 2, kidsAges: [] }]);
  const [location, setLocation] = useState<string>('');
  const history = useHistory();
  const [isFormValid, setIsFormValid] = useState<boolean>(true);
  const [locationValid, setLocationValid] = useState<boolean>(true);
  const [isDateValid, setIsDateValid] = useState<boolean>(true);
  const [showHistoryCard, setShowHistoryCard] = useState<boolean>(false);
  const [uniqueHistoryArray, setUniqueHistoryArray] = useState<any[]>([]);
  const [disable, setDisable] = useState<boolean>(true);

  const { loading, account } = login;
  const loadingSearch = login.loading;
  const leadTime = account?.leadTime;
  const disableNewTabOpen = account?.disableNewTabOpen;

  const color: any = account?.searchIconsColor;
  const styleColor = !isEmpty(color) ? { color } : {};
  const buttonColor = account?.buttonColor;

  const currency = 'USD';
  const residency = 'US';
  const STORAGE_KEY: string = 'HOTEL_RECENT_SEARCHES_V2';
  const handleSubmit = async () => {
    const isFormValid = checkIn && checkOut && location;
    if (isFormValid) {
      const dates = { checkIn, checkOut };
      const payload = {
        currency,
        filter: { exactSearch: true },
        hotelsRequest: {
          residency,
          checkIn,
          checkOut,
          location,
          rooms: rooms.map((room) => ({
            adultsCount: room.adultsCount,
            kidsAges: room.kidsAges,
          })),
        },
        pageNumber: 1,
        pageSize: 10,
        quick: false,
        searchHomes: 'All',
        sortBy: 'BiggestSavingsPercentage',
      };
      const url = `/${login.account.name}/search?dates=${btoa(JSON.stringify(dates))}&location=${btoa(
        JSON.stringify(location),
      )}&rooms=${btoa(JSON.stringify(payload.hotelsRequest.rooms))}`;
      
      if (disableNewTabOpen) {
        history.push(url);
      } else {
        window.open(url, '_blank');
      }
      const roomsFormatted = rooms.map((room) => ({
        adultsCount: room.adultsCount,
        kidsAges: room.kidsAges,
      }));

    const recentSearchesRaw = localStorage.getItem(HOTEL_RECENT_SEARCHES_LABEL);
    const recentSearches: any[] = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : [];

    const newSearch = {
      checkIn,
      checkOut,
      location,
      locationCode: location?.code,
      type: 'All',
      rooms: roomsFormatted,
    };

    const newSearchStr = JSON.stringify(newSearch);
    const isDuplicate = recentSearches.some((s: any) => JSON.stringify(s) === newSearchStr);

    if (!isDuplicate) {
      const updatedSearches = [newSearch, ...recentSearches].slice(0, 8);
      localStorage.setItem(HOTEL_RECENT_SEARCHES_LABEL, JSON.stringify(updatedSearches));
    }
    // === Recent Searches Logic Ends Here ===
      const recentSearchesData: any = { location, checkIn, checkOut, rooms };

      const storage: string | null = localStorage.getItem(STORAGE_KEY);
      const existingData: Array<{
        location: {
          code: string;
          name: string;
          type: string;
          geoLocation: {
            latitude: number;
            longitude: number;
          };
        };
        checkIn: string;
        checkOut: string;
        rooms: Array<{
          adultsCount: number;
          kidsAges: number[];
        }>;
      }> = storage ? JSON.parse(storage) : [];

      const dataExists = existingData.some(
        (search: any) =>
          search.location === recentSearchesData.location &&
          search.checkIn === recentSearchesData.checkIn &&
          search.checkOut === recentSearchesData.checkOut &&
          search.rooms === recentSearchesData.rooms,
      );

      if (!dataExists) {
        existingData.push(recentSearchesData);
      }

      localStorage.setItem(STORAGE_KEY, JSON.stringify(existingData));

    } else {
      setIsFormValid(false);
      setLocationValid(!!location);
      setIsDateValid(!!(checkIn && checkOut));
    }
  };

  const handleDateChange = (newCheckIn: string, newCheckOut: string) => {
    setCheckIn(newCheckIn);
    setCheckOut(newCheckOut);
    if(newCheckIn && newCheckOut) {
      setIsDateValid(true);
    }
  };

  const handleLocationSelect = (selectedLocation: string) => {
    setLocation(selectedLocation);
    setLocationValid(true);
  };

  const handleSearchChange = (searchInput: string) => {
    setLocation(searchInput);
    setLocationValid(true);
  };

  const recentSearchHandleSubmit = (location, rooms, checkIn, checkOut) => {
    const dates = { checkIn, checkOut };
    history.push(
      `/${login.account.name}/search?dates=${btoa(JSON.stringify(dates))}&location=${btoa(
        JSON.stringify(location),
      )}&rooms=${btoa(JSON.stringify(getNormalizedRoomsResponse(rooms)))}`,
    );
  };

  const cards = document.querySelectorAll('.history-card-text');

  cards.forEach((card: any) => {
    card.addEventListener('mouseenter', () => {
      card.style.transition = 'transform 0.3s ease-in, box-shadow 0.3s ease-in';
    });

    card.addEventListener('mouseleave', () => {
      card.style.transition = 'transform 0.9s ease-out, box-shadow 0.9s ease-out';
    });
  });

  function truncateString(str, num) {
    if (str?.length <= num) {
      return str; // Return the original string if it is shorter than the maximum length
    }
    return str?.slice(0, num) + '...'; // Truncate the string and append ellipsis
  }

  useEffect(() => {
    const storageData = localStorage.getItem('HOTEL_RECENT_SEARCHES_V2');
    if (storageData) {
      const historyData = JSON.parse(storageData);
      const filteredHistoryData = historyData.filter((entry: any) => {
        const checkInDate = new Date(entry.checkIn);
        const currentDate = new Date();
        return checkInDate >= currentDate; 
      });
      if (filteredHistoryData.length > 0) {
        const recentSearches = filteredHistoryData.slice(-3); 
        setUniqueHistoryArray(recentSearches.reverse()); 
        setShowHistoryCard(recentSearches.length > 0);
      } else {
        setUniqueHistoryArray([]); 
        setShowHistoryCard(false); 
      }
    }
  }, []);

  const totalKids = (search) =>
    search?.rooms?.reduce((total, room) => {
      return total + (room?.kidsAges?.length || 0);
    }, 0);

  return (
    <section className="pt-0">
      <div
        className="py-6 container-fluid dark-overlay"
        style={{
          backgroundImage: `url(${img})`,
          backgroundPosition: 'center left',
          backgroundSize: 'cover',
          maxHeight: '460px',
        }}
      >
        <div className="row">
          <div className="col-md-6 mx-auto text-center pt-7 pb-5 pb-sm-6 pb-lg-9">
            <h1 className="text-white"><FormattedMessage id="dashboard.inclusives.title" /></h1>
            <p className="lead text-white mb-0">
              <FormattedMessage id="dashboard.inclusives.description" />
            </p>
          </div>
        </div>
      </div>
      <div className="filterSec px-sm-0 px-3">
        <div className="container mt-n7">
          <div className="row">
            <div className="col-12">
              <div className="card shadow rounded-3 p-4">

                <SearchSelection
                  type={HOTELS_SELECTION_TYPE}
                  isWidget={false}
                />
                {/* <SearchWrapper
                  isWidget={false}
                  isVacationRentals={false}
                  hideTitle={true}
                  hideMessage={true}
                  disableLocationSearch={false}
                  hideSearchSelection={false}
                  widgetBackgroundColor={'none'}
                  excludeCondosSelection={true}
                  excludeVacationsSelection={true}
                /> */}
                  <div className="row gy-4 gx-0 mx-md-0 mx-3">
                  <div className={`col-lg-10`}>
                         <div className='row pe-2'>
                            <div className={'col-lg-6 px-0 border-right'}>
                                <LocationSelector
                                onLocationSelect={handleLocationSelect}
                                searchTerm={location}
                                onSearchChange={handleSearchChange}
                                locationValid={locationValid}
                                showLocationHistory={true}
                              />
                           </div>
                           <div className={'col-lg-3 px-0 border-right'}>
                            <div className="w-100 h-100">
                              <HotelDatePicker 
                                isUpdateSearch={false}
                                checkIn={checkIn}
                                checkOut={checkOut}
                                onDateChange={handleDateChange}
                                validate={isFormValid}
                                isDateValid={isDateValid}
                                leadTime={leadTime}
                          />
                          </div>
                           </div>
                           <div className={'col-lg-3 px-0 border-right'}>
                              <GuestsRoomsSelector
                                setDisable={setDisable}
                                rooms={rooms}
                                setRooms={setRooms}
                              />
                           </div>
                       </div>
                  </div>
                  <div className="col-lg-2 px-0">
                    <div className="h-100">
                      <BlueButton className="search-button btn btn-lg btn-primary m-0 h-100 w-100" onClick={handleSubmit} disabled={loading || loadingSearch} >
                        {/* <SearchSvg /> */}
                        <FormattedMessage id={'search'} />
                      </BlueButton>
                    </div>
                  </div>
                  </div>
              </div>
            </div>

            {showHistoryCard && (
              <section className='pb-0' style={{ paddingTop: '5rem !important' }}>
                <div className="cars-recents">
                  <h2 className="cars-recents__title secondary-font">
                    <FormattedMessage id="recents.title" /> 
                  </h2>
                  <div className="cars-recents__wrapper">
                    {uniqueHistoryArray?.map((search: any, index: number) => {
                      const checkIn = moment(search.checkIn).format('MMM-DD');
                      const checkOut = moment(search.checkOut).format('MMM-DD YYYY');
                      return (
                        <div
                          key={index}
                          role="button"
                          className={`search-recents-picker card card-body history-card-text border-1 shadow-sm p-2`}
                          onClick={() =>
                            recentSearchHandleSubmit(
                              search.location,
                              search.rooms,
                              search.checkIn,
                              search.checkOut,
                            )
                          }
                        >
                          <div className="search-recents-picker__info">
                            <h6 className="search-recents-picker__title mb-1 mt-1">
                              <i className="fas fa-map-marker-alt fs-8 me-3 mt-2 location-icon" style={{ ...styleColor }}></i>
                              <span title={search.location.name}>
                                {truncateString(search.location.name, 50)}
                              </span>
                            </h6>

                            <h6 className="recent-searches-picker__subtitle mb-1 mt-1 ttl">
                              <i className="fas fa-calendar fs-8 me-3 mt-2 location-icon" style={{ ...styleColor }}></i>
                              <span className="mb-1 mt-1 history-card-text-transform">
                                {checkIn}
                              </span>{' '}
                              -{' '}
                              <span className=" mt-1 history-card-text-transform">
                                {checkOut}
                              </span>
                            </h6>
                            <h6 className="recent-searches-picker__subtitle mb-1 mt-1 ttl pb-4">
                              <i className="fas fa-user-friends fs-8 me-3 mt-2 location-icon" style={{ ...styleColor }}></i>
                              <span>
                                <FormattedMessage id="dashboard.adult.count" />
                                {search?.rooms?.length <= 0
                                  ? 1
                                  : search?.rooms.reduce((total, room) => total + room.adultsCount, 0)
                                }
                                {', '}
                                {search?.rooms?.length <= 1 ? (
                                  <FormattedMessage id="room.title" />
                                ) : (
                                  <FormattedMessage id="rooms" />
                                )}{' '}
                                {search?.rooms?.length}
                                {totalKids(search) > 0 && (
                                  <>
                                    {', '}
                                    <FormattedMessage id="dashboard.kids.count" /> {totalKids(search)}
                                  </>
                                )}
                              </span>
                            </h6>

                            <div className={`search-again secondary-font`}  style={{color: `${buttonColor}`}}>
                              <FormattedMessage id="availability.status.modal.search_again" />
                              <img src={arrow} width={25} className="mx-2" />
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </section>
            )}
          </div>
          </div>
      </div>
    </section>
  );
};

export { DashboardHero };
